// Listen to this event to ensure the WL is loaded
function SWCallbackWishlistButtonLoaded() {
    publish(PUB_SUB_EVENTS.wishlistLoaded)
}

// PLP
function SWCallbackExpressWishlistCollectionItemAdded() {
    publish(PUB_SUB_EVENTS.wishlistCollectionItemAdded);
}

function SWCallbackExpressWishlistCollectionItemRemoved() {
    publish(PUB_SUB_EVENTS.wishlistCollectionItemRemoved);
}

function SWCallbackCustomerWishlistCollectionItemAdded() {
    publish(PUB_SUB_EVENTS.customerWishlistCollectionItemAdded);
}

function SWCallbackCustomerWishlistCollectionItemRemoved() {
    publish(PUB_SUB_EVENTS.customerWishlistCollectionItemRemoved);
}

// PDP
function SWCallbackExpressWishlistProductItemAdded() {
    publish(PUB_SUB_EVENTS.wishlistProductItemAdded);
}

function SWCallbackExpressWishlistProductItemRemoved() {
    publish(PUB_SUB_EVENTS.wishlistProductItemRemoved);
}

function SWCallbackCustomerWishlistProductItemAdded() {
    publish(PUB_SUB_EVENTS.customerWishlistProductItemAdded);
}

function SWCallbackCustomerWishlistProductItemRemoved() {
    publish(PUB_SUB_EVENTS.customerWishlistProductItemRemoved);
}